import * as React from 'react';
import styled from 'styled-components';
import { Text } from '../Text/Text';
import LightningIcon from './LightingIcon';

export interface IConsumptionBoxProps {
  currentConsumption: number;
  consumptionUnit?: string;
  description: string;
}

const StyledConsumptionBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: auto;
  height: 100%;
  padding: 0px 20px;
  background: ${({ theme }) =>
    theme.isDark ? theme.colors.white05 : '#F7F7F8'};
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  ${({ theme }) => theme.mediaQueries.medium} {
    padding: 0px 40px;
  }
`;

const StyledConsumptionDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.font1};
`;

const ConsumptionBox: React.FunctionComponent<IConsumptionBoxProps> = props => {
  const { currentConsumption, consumptionUnit = 'W', description } = props;
  return (
    <StyledConsumptionBox>
      <StyledConsumptionDetails>
        <Text bold fontSize="24px" letterSpacing="0.16px">
          {currentConsumption} {consumptionUnit}
        </Text>
        <Text fontSize="14px" letterSpacing="0.16px" fontWeight={500}>
          {description}
        </Text>
      </StyledConsumptionDetails>
      <LightningIcon />
    </StyledConsumptionBox>
  );
};

export default ConsumptionBox;
